export enum SortingOrder {
  ASC = 'asc',
  DESC = 'desc',
}
